var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUmoney = function SvgIconUmoney(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4997 0C13.6517 0 9 4.94305 9 11C9 17.1266 13.7182 22 19.4997 22C25.2811 22 29.9993 17.057 29.9993 11C30.0658 4.94305 25.2811 0 19.4997 0ZM19.4997 15.1076C17.3731 15.1076 15.5789 13.2279 15.5789 11C15.5789 8.77215 17.3731 6.89242 19.4997 6.89242C21.6262 6.89242 23.4204 8.77215 23.4204 11C23.4204 13.2279 21.6926 15.1076 19.4997 15.1076Z",
    fill: "#8B3FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3V19H5.02325L0 3H9Z",
    fill: "#8B3FFD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUmoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-umoney.b1a98672.svg";
export { ForwardRef as ReactComponent };